import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker'
import { BulkAction, DataService, ModalService } from '@vendure/admin-ui/core'
import { EMPTY, forkJoin, switchMap } from 'rxjs'
import { graphql } from './gql'

export const deleteEmploymentDocument = graphql(`
  mutation DeleteEmployment($id: ID!) {
    deleteEmployment(id: $id) {
      message
      result
    }
  }
`)

export const deleteCompanyDocument = graphql(`
  mutation DeleteCompany($id: ID!) {
    deleteCompany(id: $id) {
      message
      result
    }
  }
`)

export const deleteEmployments: BulkAction = {
  location: 'company-employment-list',
  label: _('common.delete'),
  icon: 'trash',
  iconClass: 'is-danger',
  requiresPermission: 'DeleteEmployment',
  onClick: ({ injector, selection, hostComponent, clearSelection }) => {
    const modalService = injector.get(ModalService)
    modalService
      .dialog({
        title: `org-hierarchy.delete-employments`,
        translationVars: {
          count: selection.length,
        },
        buttons: [
          { type: 'secondary', label: 'common.cancel' },
          { type: 'primary', label: 'common.delete', returnValue: true },
        ],
      })
      .pipe(
        switchMap((result) => {
          if (result) {
            return forkJoin(
              selection.map((entity) =>
                injector
                  .get(DataService)
                  .mutate(deleteEmploymentDocument, { id: entity.id }),
              ),
            )
          } else {
            return EMPTY
          }
        }),
      )
      .subscribe((response) => {
        hostComponent.refresh()
        clearSelection()
      })
  },
}

export const deleteCompanies: BulkAction = {
  location: 'company-list',
  label: _('common.delete'),
  icon: 'trash',
  iconClass: 'is-danger',
  requiresPermission: 'DeleteCompany',
  onClick: ({ injector, selection, hostComponent, clearSelection }) => {
    const modalService = injector.get(ModalService)
    modalService
      .dialog({
        title: `org-hierarchy.delete-companies`,
        translationVars: {
          count: selection.length,
        },
        buttons: [
          { type: 'secondary', label: 'common.cancel' },
          { type: 'primary', label: 'common.delete', returnValue: true },
        ],
      })
      .pipe(
        switchMap((result) => {
          if (result) {
            return forkJoin(
              selection.map((entity) =>
                injector
                  .get(DataService)
                  .mutate(deleteCompanyDocument, { id: entity.id }),
              ),
            )
          } else {
            return EMPTY
          }
        }),
      )
      .subscribe((response) => {
        hostComponent.refresh()
        clearSelection()
      })
  },
}
